import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '@dx/web/shared/environments';
import { User } from '../models/user.models';
import { StorageService } from '../shared/services/storage.service';
import { BYPASS_TOKEN } from '../Interceptor/http-token-injector';
import {finalize, tap} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  currentUser!: User;
  serverUrl = environment.serverUrl;
  role!: string | null;

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private storage: StorageService
  ) {
    if (this.storage.getItem('name') && this.storage.getItem('logined')) {
      this.currentUser = new User(this.storage.getItem('name'), '', this.storage.getItem('user_group'));
    }
  }

  login(data:any) {
    return this.httpClient.post(this.serverUrl + '/user/obtain_token/', data, { context: new HttpContext().set(BYPASS_TOKEN, true)})
      .pipe(
        tap((response: any) => {
          this.currentUser = new User(response.name, '', response.user_group);
          this.storage.setItem('name', response.name);
          this.storage.setItem('avatar', response.profile_pic);
          this.storage.setItem('user_group', response.user_group);
          this.storage.setItem('userEmail', data.email);
          this.storage.setItem('logined', 'true');
          this.router.navigate(['']);
        })
      )
  }

  getRole(){
    this.role = localStorage.getItem('user_group');
    return this.role;
  }
  logout() {
    const email = this.storage.getItem('userEmail');
    return this.httpClient.post(this.serverUrl + '/user/logout/', { email })
      .pipe(
        // We want to run following code even if success/error 
        // occurs
        finalize(() => {
          this.router.navigate(['auth/login'])
          this.storage.clear()
        } ))
  }

  // logout() {
  //   return new Promise<any>((resolve, reject) => {
  //     const email = this.storage.getItem('userEmail');
  //     if (email) {
  //       this.httpClient.post(this.serverUrl + '/user/logout/', { email }, {})
  //         .subscribe((msg) => {
  //             resolve(msg);
  //             this.router.navigate(['auth/login']);
  //           },
  //           () => {
  //             this.router.navigate(['auth/login']);
  //           }
  //         );
  //       this.storage.clear();
  //     }
  //   });
  // }

  resetPassword(email: object) {
    return this.httpClient.post(this.serverUrl + '/user/forgot_password/', email);
  }

  setNewPassword(id: number, token: string, newPassword: string) {
    return this.httpClient.post(this.serverUrl + '/user/reset_password/', { id, token, new_password: newPassword });
  }
}
